import { render, staticRenderFns } from "./SwapDetail.vue?vue&type=template&id=1147db3d&scoped=true"
import script from "./SwapDetail.vue?vue&type=script&lang=js"
export * from "./SwapDetail.vue?vue&type=script&lang=js"
import style0 from "./SwapDetail.vue?vue&type=style&index=0&id=1147db3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1147db3d",
  null
  
)

export default component.exports